import RechargeReport from '../../pages/office-app/workflow/report/recharge'
/**
 * 充值数据报表的路由配置。
 *
 * 如何访问"流程详情"路由：
 * this.$router.push({name: 'CustomerWorkflowDetail', params: {flowType: t, flowId: id}})
 */

export default [
  {
    name: 'RechargeReport',
    path: '/recharge_report',
    meta: { title: '充值数据报表' },
    component: RechargeReport
  }
]
